<script setup lang="ts">
    import ConfirmDialog from 'primevue/confirmdialog';
    import { APP_UPDATE_NOTIFICATION_DIALOG } from '@/constants';
</script>

<template>
    <ConfirmDialog
        id="app-update-notification-dialog"
        :group="APP_UPDATE_NOTIFICATION_DIALOG"
        class="app-update-notification-dialog"
        :draggable="false"
    />
</template>
